import SpinToWinConstant from '../constant/SpinToWinConstant';
import { SpinToWinPayload } from '../action/SpinToWinAction';
import { randomSpinWheelIndex } from '../constant/spinWheels';

// step: 0=intro, 1=howItWorks, 2=getStarted, 3=building
export interface SpinToWinState {
  targetPrice: number;
  timerSeconds: number;
  remainingSeconds: number;
  announcement: string;
  isStarted: boolean;
  step: number;
  firstName: string;
  lastName: string;
  storeNumber: string;
  endedAt: string;
  // Which of SPIN_WHEELS this player gets. Shared so the face on How It Works,
  // Get Started and Spin Target all match, and so the prices scored against
  // Spin Target belong to the face actually shown.
  wheelIndex: number;
  // Freezes the countdown once the design is submitted, so hitting 0 mid-save
  // can't swap the summary out for the Time Over screen.
  isTimerPaused: boolean;
}

const initialState: SpinToWinState = {
  targetPrice: 0,
  timerSeconds: 60,
  remainingSeconds: 60,
  announcement: 'Winners announced today at 4:00 PM at the HK / Craft booth.',
  isStarted: false,
  step: 0,
  firstName: '',
  lastName: '',
  storeNumber: '',
  endedAt: '',
  wheelIndex: 0,
  isTimerPaused: false,
};

interface SpinToWinAction {
  type: string;
  payload?: SpinToWinPayload | string;
}

const spinToWinReducer = (state = initialState, action: SpinToWinAction): SpinToWinState => {
  switch (action.type) {
    case SpinToWinConstant.SET_SPIN_TO_WIN:
      return { ...state, ...(action.payload as SpinToWinPayload), remainingSeconds: (action.payload as SpinToWinPayload)?.timerSeconds ?? state.remainingSeconds };
    case SpinToWinConstant.TICK_TIMER:
      return { ...state, remainingSeconds: Math.max(0, state.remainingSeconds - 1) };
    case SpinToWinConstant.SET_SPIN_RESULT:
      return { ...state, targetPrice: +(action.payload as string) };
    case SpinToWinConstant.START_SPIN_TO_WIN:
      // Pick this player's wheel as the journey begins, before any page shows one
      return { ...state, isStarted: true, step: 1, wheelIndex: randomSpinWheelIndex() };
    case SpinToWinConstant.NEXT_STEP:
      return { ...state, step: state.step + 1 };
    case SpinToWinConstant.SET_USER_DETAILS:
      return { ...state, ...(action.payload as any), step: state.step + 1 };
    case SpinToWinConstant.PAUSE_TIMER:
      return { ...state, isTimerPaused: true };
    case SpinToWinConstant.SET_CHALLENGE_END:
      return { ...state, endedAt: action.payload as string };
    case SpinToWinConstant.RESET_SPIN_TO_WIN:
      return initialState;
    default:
      return state;
  }
};

export default spinToWinReducer;
